export enum TripSanitarityCostMode {
  EuropeMode = 0,
  CountryMode = 1,
}
